import $ from 'jquery';

const ACTIVE = 'active';

export default class VertCenter {
    constructor() {
        
        this.$verts = $('.vert-center');
        this.$stories = $('.story-item');

        this.$affix = $('#story-timeline');
        this.affixStart = 0;

        if ( this.$affix.length ) {
            this.affixStart =  this.$affix.offset().top;
        }        

        // Handles things like Landing Buttons...
        $('main').on('mouseover mouseout mouseenter mouseleave', '.jsVertCenterHoverReveal', this.handleMouseReveal);
        
        this.setup();

        if ( $('#our-story').length ) {
            this.initOurStory();
        }
    }

    setup() {

        $.each(this.$verts, (index, el) => {

            let $el = $(el);
            let $reveal = $el.find('.vert-center--reveal'); 
            $reveal.data('expandHeight', $reveal.height());
            
            $el.addClass('ready');

        });
    }

    handleMouseReveal(e) {

        let $el = $(e.currentTarget);
        let $reveal = $el.find('.vert-center--reveal');

        if ( e.type == 'mouseover' || e.type == 'mouseleave' ) {
            $reveal.css('height', $reveal.data('expandHeight'));
        } else {
            $reveal.css('height', '1px');
        }
    }

    initOurStory() {

        window.addEventListener('scroll', (e) => {
            this.handleScrollReveal(e);
            this.handleAffix();
        });

        $('#story-timeline').on('click', '.jsHandleScrollTo', $.proxy(this.handleScrollTo, this));
        $('#scrollToTop').on('click', this.handleScrollBackToTop);
    }

    handleAffix() {
        
        let scrollPos = $(window).scrollTop();

        if ( scrollPos >= this.affixStart ) {
            this.$affix.addClass('affix');
        } else {
            this.$affix.removeClass('affix');
        }

    }

    handleScrollBackToTop(e) {
        e.preventDefault();

        $('html, body').animate({
            scrollTop: $('#story').offset().top,
        }, 1000);
    }

    handleScrollTo(e){
        e.preventDefault();

        let $el = $(e.currentTarget);
        let id = $el.data('id');

        $('.jsHandleScrollTo').removeClass(ACTIVE).filter($el).addClass(ACTIVE);
 
        let scrollAmt = $('#our-story').find(`[data-id="${id}"]`).offset().top - this.$affix.height(); 

        $('html, body').animate({
            scrollTop: scrollAmt,
        }, 1000);

    }

    handleScrollReveal() {
        
        // let found = false;

        for ( let i = 0; i < this.$stories.length; i++ ) {

            let el = this.$stories[i];

            if ( this.isScrolledIntoView(el) ) {
                this.handleStoryReveal(el);
                // found = true;
            } else {
                this.handleStoryHide(el);
            }

        }
    }

    handleStoryReveal(el) {
        let $el = $(el);
        let $reveal = $el.find('.vert-center--reveal');
        let id = $el.data('id');

        $el.addClass(ACTIVE);
        $reveal.css('height', $reveal.data('expandHeight'));

        this.$affix.find('button').removeClass(ACTIVE);
        this.$affix.find(`[data-id="${id}"]`).addClass(ACTIVE);
    }

    handleStoryHide(el) {
        let $el = $(el);
        let id = $el.data('id');
        let $reveal = $el.find('.vert-center--reveal');
        $el.removeClass(ACTIVE);
        $reveal.css('height', '1px');
        this.$affix.find(`[data-id="${id}"]`).removeClass(ACTIVE);
    }

    isScrolledIntoView(el) {
        let elemTop = el.getBoundingClientRect().top;
        let elemBottom = el.getBoundingClientRect().bottom;
        let adjust = 150; 

        let isVisible = (elemTop >= (0 - adjust)) && (elemBottom <= (window.innerHeight + adjust));
        return isVisible;
    }
}


// WEBPACK FOOTER //
// ./src/js/components/vertcenter.js